import { Icon } from '@advanza/ui'
import Button from '@advanza/ui/Button'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'

const SetPrimarySubscriptionModal = NiceModal.create(
    ({ subscriptionId, serviceName, onCancel, onConfirm }) => {
        const modal = useModal()

        function closeModal() {
            modal.resolve()
            modal.hide()
        }

        function triggerCancel() {
            closeModal()
            onCancel()
        }

        function triggerConfirm() {
            closeModal()
            onConfirm()
        }

        return (
            <BaseModal maxWidth={600} onClose={closeModal} closeOnOutSideClick>
                <BaseModalHeader>
                    <h2>Set Primary Subscription</h2>
                </BaseModalHeader>
                <BaseModalMainContent>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            marginBottom: '20px',
                        }}>
                        <Icon name="crown" style={{ color: '#C0C0C0', fontSize: '24px' }} />
                        <span>
                            Set subscription #{subscriptionId} ({serviceName}) as the primary
                            subscription?
                        </span>
                    </div>
                    <p>
                        This subscription will be marked as the primary subscription for this
                        provider. The primary subscription is typically used for billing and main
                        service identification.
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'flex-end',
                            marginTop: '20px',
                        }}>
                        <Button
                            style={{ padding: '9px 16px' }}
                            appearance={'outlined_primary'}
                            name="cancel"
                            onClick={triggerCancel}>
                            Cancel
                        </Button>
                        <Button
                            style={{ padding: '9px 16px' }}
                            appearance={'primary'}
                            name="confirm"
                            onClick={triggerConfirm}>
                            Set as Primary
                        </Button>
                    </div>
                </BaseModalMainContent>
            </BaseModal>
        )
    },
)

export default SetPrimarySubscriptionModal
